function removeHTMLTags(str) {
  return (str && str.replace(/<\/?[^>]+(>|$)/g, "")) || null;
}

module.exports = removeHTMLTags;
